import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import Tabs from "./Tabs";
import TabPane from "./TabPane";
//做题记录
import ExerRecordIndex from "./ExerRecordIndex";
//试题收藏
import ExerRecordQuestionCollect from "./ExerRecordQuestionCollect";
//试卷收藏
import ExerRecordPaperCollect from "./ExerRecordPaperCollect";
//我的错题
import ExerRecordMyWrong from "./ExerRecordMyWrong";
//我的笔记
import ExerRecordMyNote from "./ExerRecordMyNote";
//我的纠错
import ExerRecordMyCorrection from "./ExerRecordMyCorrection";
export class ExerRecord extends Component {
  state = {
    defaultActiveKey: 0,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillMount() {
    let { pathname } = this.props.history.location;
    pathname = pathname.slice(pathname.lastIndexOf('/') + 1, pathname.length);
    this.setState({
      defaultActiveKey: parseInt(pathname, 10),
    })
  }
  updateRouter(activeKey) {
    this.props.history.replace(`/center/exerRecord/${activeKey}`)
  }
  render() {
    const { defaultActiveKey } = this.state;
    return (
      <div className="center-exer-record">
        <div className="tabs">
          <Tabs
            {...this.props}
            defaultActiveKey={defaultActiveKey}
            onTabsChange={(activeKey) => {
              this.setState({
                defaultActiveKey: activeKey
              });
              this.updateRouter(activeKey);
            }}
            tabs={[{ Name: "做题记录" }, { Name: "试题收藏" }, { Name: "试卷收藏" }, { Name: "我的错题" }, { Name: "我的笔记" }, { Name: "我的纠错" }]}
          />
        </div>
        <TabPane {...this.props} defaultActiveKey={defaultActiveKey}>
          <ExerRecordIndex {...this.props} />
          <ExerRecordQuestionCollect {...this.props} />
          <ExerRecordPaperCollect {...this.props} />
          <ExerRecordMyWrong {...this.props} />
          <ExerRecordMyNote {...this.props} />
          <ExerRecordMyCorrection {...this.props} />
        </TabPane>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExerRecord);



// WEBPACK FOOTER //
// ./src/features/center/ExerRecord.js